import { numberFormat } from './utils';

export const yTickLabels = ['<200', '', '', '', '1000', '', '', '', '', '2000', '', '', '', '', '3000', '', '', '', '', '4000', '', '', '', '', '5000', '', '', '', '', '6000', ''];

export function getYTickLabelFormatted(lang) {
  return {
    '<200': '200',
    '1001-1200': numberFormat(1000, lang),
    '2001-2200': numberFormat(2000, lang),
    '3001-3200': numberFormat(3000, lang),
    '4001-4200': numberFormat(4000, lang),
    '5001-5200': numberFormat(5000, lang),
    '>6000': numberFormat(6000, lang)
  };
}

export default {
  yTickLabels,
  getYTickLabelFormatted
};



// WEBPACK FOOTER //
// ./src/helper/constants.js